export const FLOORS = ['Ground', 'Middle', 'Top', 'Office'];
export const FLOORS_LOWER_CASE = ['ground', 'middle', 'top', 'office'];